import { useEffect, useState } from "react";

import Helpers from "./helpers";
import { FiEdit } from "react-icons/fi";
import AutoComplete from "@src/components/Controls/AutoComplete";
import EmployerEditModal from "../Modals/EmployerEditModal";
import { useEmploymentQuery } from "../../query/useEmployment";

export default function EmployerSearch(props) {
   let cancelToken;
   if (!Object.prototype.hasOwnProperty.call(props, "onSelect")) {
      console.error("Employer search requires an 'onSelect' property");
   }
   const { data: employmentData } = useEmploymentQuery();
   const knownEmployers = employmentData?.employers || [];
   const [employers, setEmployers] = useState([]);
   const [employerName, setEmployerName] = useState("");
   const [prev, UpdatePrev] = useState("");
   const [editEmployerId, setEditEmployerId] = useState(null);

   useEffect(() => {
      setEmployerName(props.value || "");
   }, [props.value]);

   async function onChangeAsync(newValue) {
      setEmployerName(newValue);
      if (!newValue) return;
      if (typeof cancelToken != typeof undefined) {
         cancelToken.cancel("Operation cancelled do to new request.");
      }
      var addLocal = false;
      if (newValue && newValue !== props.value) {
         if (newValue.length > 3) {
            if (prev && newValue.indexOf(prev) >= 0 && employers.length > 1) {
               addLocal = true;
            } else {
               var resp = await Helpers.EmployersAsync(newValue);
               if (resp && resp.length > 0) setEmployers(resp);
               else addLocal = true;
            }
         } else addLocal = true;
      }
      if (addLocal) {
         UpdatePrev(newValue);
      }
   }

   function onSelect(value) {
      if (!value) return;
      var employer = value;
      if (typeof value === "string") {
         var matches = employers.filter((e) => e.Name === value);
         if (matches.length === 0)
            matches = knownEmployers.filter((e) => (e.Name || "").toLowerCase() === value.toLowerCase());
         if (matches.length === 0)
            matches = knownEmployers.filter((e) => (e.Name || "").toLowerCase().indexOf(value.toLowerCase()) === 0);
         if (matches.length > 0) {
            employer = matches[0];
         } else {
            employer = {
               ID: Math.floor(Math.random() * -10000) - 1,
               id: Math.floor(Math.random() * -10000) - 1,
               Name: value,
            };
         }
         employer.Name = employer.Name || value;
         setEmployerName(employer.Name);
      }
      setEmployers([]);
      if (props.onSelect) {
         props.onSelect(employer);
      }
   }

   function editEmployer() {
      const id = Number(props.valueId) || 0;
      if (id > 0) setEditEmployerId(id);
   }

   function handleKeypress(e) {
      if (e.key === "Enter") {
         onSelect(employerName);
      }
   }

   return (
      <div className="field EmployerSearch">
         <AutoComplete
            freeSolo
            autoComplete
            value={employerName}
            options={employers.map((e) => e.Name)}
            onInputChange={(e, value) => onChangeAsync(value)}
            onChange={(e, value) => {
               onSelect(value);
            }}
            renderInput={(params) => <input type="text" {...params} label={props.label} />}
            onBlur={() => onSelect(employerName)}
            onKeyPress={handleKeypress}
         />
         <FiEdit size={1} onClick={editEmployer} />
         {editEmployerId != null ? (
            <EmployerEditModal
               employerId={editEmployerId}
               onClose={() => setEditEmployerId(null)}
            />
         ) : null}
      </div>
   );
}
